import { testimonials } from '@/mocks/gossip';

export default function About() {
  return (
    <>
      {/* 品牌介绍 + 用户口碑 */}
      <section id="about" className="scroll-mt-24">
        <div className="mx-auto w-full max-w-[1280px] px-4 py-16 md:px-6">
          <div className="grid grid-cols-1 items-start gap-10 lg:grid-cols-2">
            <div>
              <p className="flex items-center gap-2 text-sm font-medium text-accent-600">
                <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
                ABOUT 99BAOLIAO
              </p>
              <h2 className="mt-2 font-heading text-3xl font-black tracking-tight text-foreground-950">
                记录真实，也尊重分寸
              </h2>
              <p className="mt-5 text-base leading-relaxed text-foreground-700">
                99爆料相信，任何行业都不止镜头里、报表上的那一面。我们关注台前幕后的真实细节，希望通过"圈内人提供线索 + 编辑部多方核验"的方式，为关心真相的读者提供一个更完整的视角。
              </p>
              <p className="mt-3 text-base leading-relaxed text-foreground-700">
                我们坚持三条内容原则：<strong className="font-semibold text-foreground-900">来源可追溯</strong>、
                <strong className="font-semibold text-foreground-900">事实多源印证</strong>、
                <strong className="font-semibold text-foreground-900">观点诚实标注</strong>。
                对暂时无法核实的信息，我们会坦白说明，而不是用情绪化的标题让读者替我们猜测。
              </p>

              <dl className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3">
                {[
                  { num: '6', label: '个核心圈层栏目' },
                  { num: '100+', label: '位行业受访者' },
                  { num: '365', label: '天全年持续更新' },
                ].map((s) => (
                  <div key={s.label} className="rounded-lg border border-background-200 bg-background-50 p-4">
                    <dt className="font-heading text-2xl font-black text-primary-500">{s.num}</dt>
                    <dd className="mt-1 text-xs text-foreground-600">{s.label}</dd>
                  </div>
                ))}
              </dl>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100/60 p-6 md:p-8">
              <h3 className="font-heading text-xl font-bold text-foreground-900">读者怎么说</h3>
              <div className="mt-6 space-y-5">
                {testimonials.map((t) => (
                  <figure key={t.name} className="rounded-lg bg-background-50 p-5">
                    <i className="ri-double-quotes-l text-2xl text-accent-400" />
                    <blockquote className="mt-2 text-sm leading-relaxed text-foreground-700">
                      {t.quote}
                    </blockquote>
                    <figcaption className="mt-4 flex items-center gap-3">
                      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 text-sm font-bold text-secondary-700">
                        {t.name.charAt(0)}
                      </span>
                      <div>
                        <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                        <p className="text-xs text-foreground-500">{t.role}</p>
                      </div>
                    </figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 免责声明 */}
      <section className="mx-auto w-full max-w-[1280px] px-4 pb-16 md:px-6">
        <div className="rounded-lg border border-background-200 bg-background-50 p-6">
          <div className="flex items-start gap-3">
            <i className="ri-shield-check-line mt-0.5 text-xl text-secondary-500" />
            <div>
              <h4 className="font-heading text-base font-bold text-foreground-900">
                内容与免责说明
              </h4>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                本网站内容以圈内观察与从业者见闻为主，属于带有主观视角的信息分享，不等同于官方公告或事实定论。涉及具体机构、品牌与个人的说法，我们已尽力多源核验，但仍可能存在信息差。标注为"待核实""单方说法""行业观点"的内容，请读者理性看待。如有任何内容与事实不符，欢迎通过"我要投稿"页面向我们反馈，我们将认真复核并及时更正。为保护投稿人与当事人的合法权益，我们对涉及隐私的信息默认进行脱敏处理。
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}